import styled from 'styled-components';
import HOC from '../../HOC';
import images from '../../../images';
import BodyText from '../../../common/BodyText';
import { __ } from '../../../locales';
import { iframeCall } from '../../../helpers/iframeHelper';
import CustomButton from '../../../common/CustomButton';

const Container = styled.div`
  background-image: url(${images.kids_bg});
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 30px 0;
`;

const Body = styled.p`
  text-align: center;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 10px;
`;

const RcKids = ({
  kidsData, projectId, dzBrandConfigs, lang
}) => {
  const isCMApp = projectId?.startsWith('CIRCMAT'); // Circular Materials urls
  const isFrench = lang === 'fr_CA';

  const urls = isCMApp
    ? {
      age3to5: isFrench
        ? 'https://cdn.recyclecoach.com/resources/kids-recycle-kit/2025-03-circular-materials/3-5-FR.pdf'
        : 'https://cdn.recyclecoach.com/resources/kids-recycle-kit/2025-03-circular-materials/3-5.pdf',
      age6to8: isFrench
        ? 'https://cdn.recyclecoach.com/resources/kids-recycle-kit/2025-03-circular-materials/6-8-FR.pdf'
        : 'https://cdn.recyclecoach.com/resources/kids-recycle-kit/2025-03-circular-materials/6-8.pdf',
      age9to12: isFrench
        ? 'https://cdn.recyclecoach.com/resources/kids-recycle-kit/2025-03-circular-materials/9-12-FR.pdf'
        : 'https://cdn.recyclecoach.com/resources/kids-recycle-kit/2025-03-circular-materials/9-12.pdf'
    }
    : {
      age3to5: 'https://cdn.recyclecoach.com/resources/kids-recycle-kit/2026_03/2026_03_11_3_5.pdf',
      age6to8: 'https://cdn.recyclecoach.com/resources/kids-recycle-kit/2026_03/2026_03_11_6_8.pdf',
      age9to12: 'https://cdn.recyclecoach.com/resources/kids-recycle-kit/2026_03/2026_03_11_9_12.pdf'
    };

  const EVENT_PREFIX = 'KIDS_KIT_PDF_DOWNLOAD__MAR_2026_';

  return (
    <Container>
      <BodyText>
        <Title>
          {dzBrandConfigs?.dzTextConfig?.kidsPackageTitle || kidsData.kids_kit_title}
        </Title>
        <Body>
          {dzBrandConfigs?.dzTextConfig?.kidsPackageBody || __('app.get_your_kids_involved_food_waste')}
        </Body>
      </BodyText>
      <div style={{
        width: '100%', display: 'flex', justifyContent: 'space-between', gap: 10, padding: '0 4px'
      }}
      >
        <CustomButton
          accessibilityRole="link"
          className="btn outline royal"
          onClick={(e) => {
            e.preventDefault();
            iframeCall(`openLink?link=${urls.age3to5}`);
            iframeCall(`track?data=${JSON.stringify({ event: `${EVENT_PREFIX}AGE_3_to_5` })}`);
          }}
        >
          {__(isCMApp
            ? 'app.age_3_6'
            : 'app.age_3_5')}
        </CustomButton>
        <CustomButton
          accessibilityRole="link"
          className="btn outline royal"
          onClick={(e) => {
            e.preventDefault();
            iframeCall(`openLink?link=${urls.age6to8}`);
            iframeCall(`track?data=${JSON.stringify({ event: `${EVENT_PREFIX}AGE_6_to_8` })}`);
          }}
        >
          {__(isCMApp
            ? 'app.age_6_10'
            : 'app.age_6_8')}
        </CustomButton>
        <CustomButton
          accessibilityRole="link"
          className="btn outline royal"
          onClick={(e) => {
            e.preventDefault();
            iframeCall(`openLink?link=${urls.age9to12}`);
            iframeCall(`track?data=${JSON.stringify({ event: `${EVENT_PREFIX}AGE_9_to_12` })}`);
          }}
        >
          {__(isCMApp
            ? 'app.posters_or_more'
            : 'app.age_9_12')}
        </CustomButton>
      </div>
    </Container>
  );
};

export default HOC(RcKids);
